/** Internal tag used to filter LIA-specific notifications from the feed. Not displayed to users. */
export const INTERNAL_TAG = 'lia';

export function getVisibleTags(tags: string[]): string[] {
  return tags.filter(tag => tag !== INTERNAL_TAG);
}

export interface TagConfigEntry {
  label: string;
  color: string;
  textColor: string;
  dotColor?: string;
}

export const TAG_CONFIG: Record<string, TagConfigEntry> = {
  release: {
    label: 'Releases',
    color: 'bg-grey-90',
    textColor: 'text-white'
  },
  update: {
    label: 'Updates',
    color: 'bg-grey-70',
    textColor: 'text-white'
  },
  lgm: {
    label: 'LGM',
    color: 'bg-light-blue',
    textColor: 'text-text-blue',
    dotColor: 'bg-text-blue'
  },
  lrp: {
    label: 'LRP',
    color: 'bg-light-orange',
    textColor: 'text-text-orange',
    dotColor: 'bg-orange'
  },
  drp: {
    label: 'DRP',
    color: 'bg-hover-green',
    textColor: 'text-green',
    dotColor: 'bg-green'
  }
};

const DEFAULT_TAG_CONFIG: TagConfigEntry = {
  label: '',
  color: 'bg-background-grey',
  textColor: 'text-grey-70'
};

export function getTagConfig(tagKey: string): TagConfigEntry {
  const entry = TAG_CONFIG[tagKey];
  if (entry) return entry;
  return { ...DEFAULT_TAG_CONFIG, label: tagKey };
}
